export default "__VITE_ASSET__Ar4ElVi$__"